import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utility/axiosInstance';

export interface LoadBalancer {
    id: string;
    name: string;
    operating_status: string;
    provisioning_status: string;
    vip_address: string;
    vip_port_id: string;
    vip_subnet_id: string;
    vip_network_id: string;
    tags?: string[];
    listeners?: any[];
    pools?: any[];
}

interface LoadBalancersState {
    data: LoadBalancer[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: LoadBalancersState = {
    data: [],
    status: 'idle',
    error: null,
};

export const fetchLoadBalancers = createAsyncThunk('loadBalancers/fetchLoadBalancers', async () => {
    const response = await axiosInstance.get('/v1/load_balancers');
    return response.data;
});

const loadBalancersSlice = createSlice({
    name: 'loadBalancers',
    initialState,
    reducers: {
        updateLoadBalancer: (state, action) => {
            const index = state.data.findIndex((lb) => lb.id === action.payload.id);
            if (index !== -1) {
                state.data[index] = action.payload;
            } else {
                state.data.unshift(action.payload);
            }
        },
        removeLoadBalancer: (state, action) => {
            state.data = state.data.filter((lb) => lb.id !== action.payload.id);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoadBalancers.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLoadBalancers.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLoadBalancers.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'Failed to fetch load balancers';
            });
    },
});

export const { updateLoadBalancer, removeLoadBalancer } = loadBalancersSlice.actions;
export default loadBalancersSlice.reducer;
